import React from 'react'
import PropTypes from 'prop-types'
import { forceCheck } from 'react-lazyload'
import isBefore from 'date-fns/isBefore'
import addDays from 'date-fns/addDays'
import startOfDay from 'date-fns/startOfDay'
import styled from 'styled-components'
import BooleanValue from '../../../components/admin/BooleanValue'
import FormatName from '../../../components/ygo/FormatName'
import { OCG } from '../../../data/formats'
import Icon from '../../../components/general/Icon'
import FlyoutLegalStatus from '../FlyoutLegalStatus'
import { LegalInfoFlyOut, StatsItem, StatsLabel } from '../Toolbar'

const StatsLegalStatus = ({ deck, toggleLegalInfo }) => {
	const legal = deck.legalSince && isBefore(new Date(deck.legalSince), addDays(startOfDay(new Date()), 1))
	const legalFuture = deck.legalSince && !isBefore(new Date(deck.legalSince), addDays(startOfDay(new Date()), 1))
	const saveToSeeStatus = deck.changes.cards || deck.changes.format || deck.changes.season

	return (
		<StatsItem onClick={toggleLegalInfo} onMouseOver={forceCheck}>
			{!saveToSeeStatus && legal && !legalFuture && (
				<>
					<BooleanValue>{true}</BooleanValue>
				</>
			)}
			{!saveToSeeStatus && !legal && legalFuture && !deck.legalStatus && deck.legalSinceSet && (
				<FutureWrapper>
					<Future>{deck.legalSinceSet.setNumber || deck.legalSinceSet.name.slice(0, 5)}</Future>
				</FutureWrapper>
			)}
			{!saveToSeeStatus && !legal && deck.legalStatus === 'ocg' && (
				<>
					<FormatName format={OCG} />
				</>
			)}
			{!saveToSeeStatus && !legal && !legalFuture && !deck.legalStatus && (
				<>
					<BooleanValue>{false}</BooleanValue>
				</>
			)}
			{saveToSeeStatus && (
				<>
					<Icon name="question-mark-circle" size={16} top={3} />
				</>
			)}
			<StatsLabel>Status</StatsLabel>

			<LegalInfoFlyOut>
				<FlyoutLegalStatus deck={deck} />
			</LegalInfoFlyOut>
		</StatsItem>
	)
}

StatsLegalStatus.propTypes = {
	deck: PropTypes.object.isRequired,
	toggleLegalInfo: PropTypes.func.isRequired
}

const FutureWrapper = styled.div`
	font-size: 0.8rem;
	font-weight: 400;
	white-space: nowrap;
`

const Future = styled.div`
	background: ${props => props.theme.green};
	border-radius: 4px;
	color: #FFF;
	font-weight: 800;
	height: 20px;
	margin-top: 2px;
	padding: 0 0.25rem;

	align-items: center;
	display: flex;
	justify-content: center;
`

export default StatsLegalStatus
